import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {
  RequestBodyListingDto, RequestParamListingDto,
  RequestSaveDto,
  ResponseGetReservedWordDto,
  ResponseListingDto
} from "../dto/sf-formula.dto";
import {Injectable} from "@angular/core";
import {ResponseData, ResponsePaging} from "../../nest-responses";

@Injectable()
export class SfFormulaApi {

  private readonly service: string = '';
  private readonly model: string = 'sfFormula';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(): Observable<ResponseData<ResponseListingDto>> {
    const method: string = 'POST';
    const func: string = 'listing';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseListingDto>>(method, url, params, urlParams, body);
  }

  public getReserword(query: RequestParamListingDto, payload: RequestBodyListingDto): Observable<ResponsePaging<ResponseGetReservedWordDto>> {
    const method: string = 'POST';
    const func: string = 'getReserword';
    const params: any = payload || {};
    const urlParams: any = query || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseGetReservedWordDto>>(method, url, params, urlParams, body);
  }

  public save(payload: RequestSaveDto[]): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-formula.api.ts